/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uVariable = A4uVariable;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uVariable(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M10.909,10.692c-.093-.123-.06-.278.155-.278h3.691c.216,0,.278.033.371.215l2.922,5.325h.062l3.077-5.385c.093-.155.123-.155.278-.155h3.26c.186,0,.248.093.156.248-1.078,1.721-3.448,5.508-4.648,7.2,1.323,2.062,3.878,5.908,4.956,7.479.123.123.06.246-.156.246H21.25a.446.446,0,0,1-.4-.246l-3.077-5.354h-.03L14.572,25.4c-.062.122-.125.185-.338.185H10.939a.173.173,0,0,1-.153-.278c1.293-1.937,3.415-5.322,4.738-7.262ZM9.139,31.717a.991.991,0,0,0,.237-1.359A22.447,22.447,0,0,1,5.577,18a22.445,22.445,0,0,1,3.8-12.358.991.991,0,0,0-.238-1.359L7.916,3.411a1.015,1.015,0,0,0-1.428.253A25.936,25.936,0,0,0,2.077,18,25.942,25.942,0,0,0,6.488,32.337a1.014,1.014,0,0,0,1.428.253Zm18.945.873a1.014,1.014,0,0,0,1.428-.253A25.942,25.942,0,0,0,33.923,18,25.936,25.936,0,0,0,29.512,3.664a1.015,1.015,0,0,0-1.428-.253l-1.222.872a.991.991,0,0,0-.238,1.359A22.445,22.445,0,0,1,30.423,18a22.447,22.447,0,0,1-3.8,12.358.991.991,0,0,0,.237,1.359Z"
  }));
}